import { adValues } from '@tiger/ads';
import TB from '@tiger/bridge';
import { createHttpMiddleware, SWRConfig } from '@tiger/swr';
import { init as trackInit } from '@tiger/track';
import { Provider } from 'mobx-react';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import { setErrorLevel } from 'react-bootstrap-formutil';
import { BrowserRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { ModalRoot } from 'components/base/Modal';
import useLinkInterceptor from 'hooks/useLinkInterceptor';
import security, { FB_PIXEL_ID_MAP } from 'stores/security';
import ui from 'stores/ui';
import values from 'stores/values';
import { ErrorBoundary } from 'utils/bugsnag';
import http from 'utils/http';
import { momentLanguage } from 'utils/i18n';
import App from './App';

const stores = {
    values,
    security,
    ui
};

setErrorLevel(0);

const Root: React.FC = () => {
    useLinkInterceptor();

    useEffect(() => {
        TB.enableNativeShare(false);
    }, []);

    const swrConfig = useMemo(
        () => ({
            use: [createHttpMiddleware(http.request)]
        }),
        []
    );

    return (
        <ErrorBoundary>
            <SWRConfig value={swrConfig}>
                <Provider {...stores}>
                    <BrowserRouter basename={process.env.BASE_NAME}>
                        <App />
                        <ModalRoot />
                    </BrowserRouter>
                </Provider>
            </SWRConfig>
        </ErrorBoundary>
    );
};

export default hot(module)(Root);

// 初始化 moment 国际化 http://momentjs.cn/docs/#/i18n/
moment.locale(momentLanguage);

trackInit({
    fbq: FB_PIXEL_ID_MAP.old,
    // twitter 邀请码时才进行初始化twitter
    twq: adValues.invite && ui.twitterCodes[adValues.invite] && 'o3ic9'
});

trackInit({ fbq: FB_PIXEL_ID_MAP.new });
